import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/database'

const db = firebase.initializeApp({ projectId: 'covid19th', databaseURL: 'https://covid19th.firebaseio.com', }).database()

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    locations: [],
  },
  mutations: {
    setLocation(state, data) {
      state.locations = data
    }
  },
  getters: {
    getDisplayableLocation: (state) => (isShowAll) => {
      if (state.locations === []) return []
      if (isShowAll) {
        return state.locations.filter( (x) => { return x.display })
      }
      return state.locations.filter( (x) => { return x.display }).filter( (x) => { return x.all_case })
    }
  },
  actions: {
    init: function (store) {
      db.ref('/locations').once('value').then(function(snapshot) {
        const data = snapshot.val().filter((x) => {
          return x != undefined
        });
        console.log(data)
        store.commit('setLocation', data)
      });
    }
  }
})
